// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./dictionary/en.json";
import pt from "./dictionary/pg.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
  },
  lng: "pt", // ✅ Default language is English
  fallbackLng: "pt",
  interpolation: { escapeValue: false },
});

export default i18n;
